'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addOptionsToDropdown = function addOptionsToDropdown(start, end, category) {
  var options = [category];
  for (var i = start; i <= end; i++) {
    options.push(Math.abs(i));
  }
  return options.map(function (item, index) {
    return _react2.default.createElement(
      'option',
      { disabled: !index, key: index, value: !index && 'default' || item },
      item
    );
  });
};

var SelectNumberDropdown = function SelectNumberDropdown(props) {
  return _react2.default.createElement(
    'select',
    { className: props.className,
      onChange: function onChange(event) {
        props.onOptionSelect(event.target.value);
      },
      defaultValue: 'default' },
    addOptionsToDropdown(props.start, props.end, props.category),
    ';'
  );
};

SelectNumberDropdown.propTypes = {
  end: require('react').PropTypes.number.isRequired,
  className: require('react').PropTypes.string.isRequired,
  category: require('react').PropTypes.string.isRequired,
  start: require('react').PropTypes.number.isRequired,
  onOptionSelect: require('react').PropTypes.func.isRequired
};
SelectNumberDropdown.displayName = 'SelectNumberDropdown';

SelectNumberDropdown.defaultProps = {
  className: 'SelectNumberDropdown'
};

exports.default = SelectNumberDropdown;


// WEBPACK FOOTER //
// ./components/sign-up-modal/lib/components/select-number-dropdown.js